import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { CustomFieldEntityType } from "../../../../types/custom-field";
import { UserPageUserContext, UserPageUserContextProvider, } from "../../../providers/UserPageUserContextProvider";
import { CustomFieldsWrap } from "../../CustomField/CustomFieldsWrap/CustomFieldsWrap";
import { PageContentWrap, PageTitle, PageWrap } from "../Page/Page";
import { ProfileActions } from "./components/ProfileActions/ProfileActions";
import { UserDetails } from "./components/UserDetails/UserDetails";
function PprofilePage() {
    return (_jsx(UserPageUserContextProvider, { children: _jsx(ProfilePageContent, {}) }));
}
function ProfilePageContent() {
    const { state: { loading, user, customFields }, loadUserData, } = useContext(UserPageUserContext);
    if (!user) {
        return null;
    }
    return (_jsx(PageWrap, { loading: loading, onRefresh: loadUserData, children: _jsxs(PageContentWrap, { children: [_jsx(PageTitle, { children: __("User details", "quicktasker") }), _jsxs("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-gap-3", children: [_jsx(UserDetails, { user: user }), _jsx(CustomFieldsWrap, { entityId: user.id, entityType: CustomFieldEntityType.User, entity: user, customFields: customFields }), _jsx(ProfileActions, {})] })] }) }));
}
export { PprofilePage };
